import { ArboProperty } from "../types"

export function discoverOperation(arbo: ArboProperty): string {
  const finalidade = arbo.finalidade?.toLowerCase() || ""
  
  if (finalidade.includes("venda") || finalidade.includes("vender")) {
    return "sale"
  }
  
  if (finalidade.includes("aluguel") || finalidade.includes("alugar") || finalidade.includes("locação")) {
    return "rent"
  }
  
  if (finalidade.includes("temporada")) {
    return "season"
  }
  
  if (arbo.valor_venda && arbo.valor_venda > 0) {
    return "sale"
  }
  
  if (arbo.valor_aluguel && arbo.valor_aluguel > 0) {
    return "rent"
  }
  
  return "sale"
}